import script from "./Video generates.vue?vue&type=script&setup=true&lang=js"
export * from "./Video generates.vue?vue&type=script&setup=true&lang=js"

import "./Video generates.vue?vue&type=style&index=0&id=68c27a88&lang=less&scoped=true"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.4_vue@3.5.4_webpack@5.94.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68c27a88"]])

export default __exports__